import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';

// Sets the browser tab title for a page.
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · Kalyani Consultancy` : 'Kalyani Consultancy · Insurance & Mutual Funds in Haldia';
  }, [title]);
}

// Labelled grey box where a real photo will go (we never show made-up photos of people).
export function PhotoSlot({ label, className = '' }) {
  return (
    <div className={`photo-slot flex items-center justify-center text-center text-slate-500 text-sm p-4 ${className}`} role="img" aria-label={label}>
      <span>📷<br />{label}</span>
    </div>
  );
}

export function Breadcrumb({ current }) {
  const { t } = useLang();
  return (
    <div className="text-sm text-slate-500 mb-3">
      <Link to="/" className="hover:text-ink">{t('crumbHome')}</Link> / <span>{current}</span>
    </div>
  );
}
